var _circle, _circle2, _polygon, _g, _g2, _g3, _rect, _ellipse, _ellipse2, _ellipse3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroYouth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "78 56 380 282",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Three young people starting their first jobs: a graduate, a student with headphones and a barista") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 200,
    r: 160,
    fill: "#e0e7ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 96,
    r: 34,
    fill: "#fef3c7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "380,74 386,90 403,90 389,100 394,117 380,107 366,117 371,100 357,90 374,90",
    fill: "#f59e0b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c7d2fe"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 168,
    width: 40,
    height: 150,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 128,
    width: 36,
    height: 190,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 146,
    width: 40,
    height: 172,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 188,
    width: 48,
    height: 130,
    rx: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#a5b4fc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 102,
    width: 12,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 138,
    width: 32,
    height: 180,
    rx: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250,66 254,102 246,102"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 182,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 182,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 142,
    width: 8,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 142,
    width: 8,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 152,
    width: 7,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 152,
    width: 7,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 160,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 160,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 202,
    width: 11,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 202,
    width: 11,
    height: 11,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 318,
    width: 360,
    height: 8,
    rx: 4,
    fill: "#818cf8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#4338ca",
    opacity: 0.18
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 236,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#4338ca",
    opacity: 0.18
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#4338ca",
    opacity: 0.18
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 318 q0 -9 9 -9 h3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#6366f1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#7c4a1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 186 q9 7 18 0",
    fill: "none",
    stroke: "#4f51c0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 194 Q121.5 219.0 124 244",
    fill: "none",
    stroke: "#6366f1",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 244,
    r: 5.5,
    fill: "#8d5524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 194 Q180.5 203.0 180 212",
    fill: "none",
    stroke: "#6366f1",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 212,
    r: 5.5,
    fill: "#8d5524"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 152,
    r: 18,
    fill: "#8d5524"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 153,
    r: 3.5,
    fill: "#8d5524"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 153,
    r: 3.5,
    fill: "#8d5524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 150 q-1 -21 18 -21 q19 0 18 21 q-6 -9 -18 -10 q-12 1 -18 10 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 137 q17 -8 34 0 v6 q-17 -6 -34 0 z",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124,132 150,121 176,132 150,143",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 135 v14",
    stroke: "#f59e0b",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 151,
    r: 3,
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(8 184 213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 198,
    width: 24,
    height: 30,
    rx: 3,
    fill: "#ffffff",
    stroke: "#6366f1",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 205,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#6366f1",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 212,
    width: 10,
    height: 3,
    rx: 1.5,
    fill: "#d1d5db"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 190,
    width: 52,
    height: 50,
    rx: 12,
    fill: "#f43f5e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 318 q0 -9 9 -9 h3 v9 z",
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#14b8a6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#d5b89d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 186 q9 7 18 0",
    fill: "none",
    stroke: "#109384",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 194 Q206.5 218.0 208 242",
    fill: "none",
    stroke: "#14b8a6",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 242,
    r: 5.5,
    fill: "#f3d2b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 194 Q265.5 218.0 264 242",
    fill: "none",
    stroke: "#14b8a6",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 242,
    r: 5.5,
    fill: "#f3d2b3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 152,
    r: 18,
    fill: "#f3d2b3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 153,
    r: 3.5,
    fill: "#f3d2b3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 153,
    r: 3.5,
    fill: "#f3d2b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 146 q1 -17 17 -17 q16 0 17 17 q-8 -6 -17 -6 q-9 0 -17 6 z",
    fill: "#a16207"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 152 q0 -30 21 -30 q21 0 21 30",
    fill: "none",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 145,
    width: 9,
    height: 15,
    rx: 4,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 145,
    width: 9,
    height: 15,
    rx: 4,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 186 q-3 24 -2 46",
    fill: "none",
    stroke: "#f43f5e",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 186 q3 24 2 46",
    fill: "none",
    stroke: "#f43f5e",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 318 q0 -9 9 -9 h3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 152 q0 -28 21 -28 q21 0 21 28 v18 q-21 6 -42 0 z",
    fill: "#3f1d0b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 206 h30 v42 q-15 6 -30 0 z",
    fill: "#78350f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 207 L311 187 M332 207 L325 187",
    stroke: "#78350f",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#be8c59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 186 q9 7 18 0",
    fill: "none",
    stroke: "#c6c8c9",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 194 Q289.0 217.0 291 240",
    fill: "none",
    stroke: "#f8fafc",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 240,
    r: 5.5,
    fill: "#d9a066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 194 Q345.5 208.0 342 222",
    fill: "none",
    stroke: "#f8fafc",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 222,
    r: 5.5,
    fill: "#d9a066"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 152,
    r: 18,
    fill: "#d9a066"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 153,
    r: 3.5,
    fill: "#d9a066"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 153,
    r: 3.5,
    fill: "#d9a066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 154 q-1 -25 19 -25 q20 0 19 25 q-4 -12 -19 -13 q-15 1 -19 13 z",
    fill: "#3f1d0b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 206,
    width: 12,
    height: 14,
    rx: 2,
    fill: "#ffffff",
    stroke: "#78350f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 203,
    width: 14,
    height: 4,
    rx: 2,
    fill: "#78350f"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(358 250) rotate(4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 54,
    rx: 11,
    fill: "#ffffff",
    stroke: "#c7d2fe",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 10,
    fill: "#6366f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19 l3.5 3.5 l7 -7.5",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 12,
    width: 50,
    height: 6,
    rx: 3,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 23,
    width: 34,
    height: 5,
    rx: 2.5,
    fill: "#d1d5db"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 73,
    height: 7,
    rx: 3.5,
    fill: "#e0e7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 46,
    height: 7,
    rx: 3.5,
    fill: "#6366f1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#f59e0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 112 l4 9 l9 4 l-9 4 l-4 9 l-4 -9 l-9 -4 l9 -4 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 172 l3 6 l6 3 l-6 3 l-3 6 l-3 -6 l-6 -3 l6 -3 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroYouth);
export default __webpack_public_path__ + "static/media/hero-youth.7967c95c6f82c7022ae7bd2ce4ea84e2.svg";
export { ForwardRef as ReactComponent };